export default {
  AG_GRID_LICENSE_KEY: import.meta.env.VITE_AG_GRID_LICENSE_KEY,

  // This is used to store API token in localStorage
  API_TOKEN: "apiToken",
  APP_ENV: import.meta.env.DEV ? "local" : "production",
  CUSTOM_DOMAIN_SUFFIX: import.meta.env.DEV
    ? "fulflld-local.live:5174"
    : "fulflld.live",
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_ID: "d3e43d76dedb7314",
  LIVEKIT_URL: import.meta.env.DEV
    ? "ws://localhost:7880"
    : "wss://livekit.fulflld.com",
  PREVIEW_DOMAIN: import.meta.env.DEV
    ? ".fulflld-local.live:5174"
    : ".fulflld.live",
  SOKETI_APP_KEY: import.meta.env.VITE_SOKETI_APP_KEY,
  SOKETI_HOST: import.meta.env.DEV
    ? import.meta.env.VITE_SOKETI_HOST
    : "soketi.fulflld.com",
  SOKETI_PORT: import.meta.env.DEV ? import.meta.env.VITE_SOKETI_PORT : 443,
  VAPID_PUBLIC_KEY: (import.meta.env.VITE_VAPID_PUBLIC_KEY as string) || "",
  WEB_API_URL: import.meta.env.DEV
    ? import.meta.env.VITE_WEB_API_URL || "http://localhost:8080"
    : "https://app-server.fulflld.com",
  WEB_APP_URL: import.meta.env.DEV
    ? "http://localhost:5173"
    : "https://app.fulflld.com",
};
